import React, { useEffect, useState } from "react";

export default function Countdown({ endsAt, compact = false }) {
  const [remaining, setRemaining] = useState(() => diff(endsAt));

  useEffect(() => {
    const t = setInterval(() => setRemaining(diff(endsAt)), 1000);
    return () => clearInterval(t);
  }, [endsAt]);

  if (!endsAt) return null;
  if (remaining.total <= 0)
    return <span className="text-red-400 text-sm" data-testid="countdown-expired">OFFER EXPIRED</span>;

  const Cell = ({ v, l }) => (
    <div className="flex flex-col items-center">
      <div className={`glass rounded-lg px-3 py-2 min-w-[54px] text-center font-display font-bold ${compact ? "text-lg" : "text-2xl"}`}>{String(v).padStart(2, "0")}</div>
      <div className="mt-1 text-[10px] uppercase tracking-[0.2em] text-ink-500">{l}</div>
    </div>
  );

  return (
    <div className="flex items-center gap-2" data-testid="countdown-timer">
      <Cell v={remaining.days} l="Days" />
      <Cell v={remaining.hours} l="Hrs" />
      <Cell v={remaining.minutes} l="Min" />
      <Cell v={remaining.seconds} l="Sec" />
    </div>
  );
}

function diff(endsAt) {
  if (!endsAt) return { total: 0 };
  const end = new Date(endsAt).getTime();
  const total = end - Date.now();
  if (total <= 0) return { total: 0, days: 0, hours: 0, minutes: 0, seconds: 0 };
  return {
    total,
    days: Math.floor(total / (1000 * 60 * 60 * 24)),
    hours: Math.floor((total / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((total / (1000 * 60)) % 60),
    seconds: Math.floor((total / 1000) % 60),
  };
}
